import React from 'react';
import Seo from '@/components/Seo';
import { Button, Container } from '@/components/ui';

/**
 * Catch-all 404 page.
 *
 * Rendered for any route that doesn't match `/` (see the `path="*"` route in
 * `App.tsx`). Marked `noindex` so search engines never index it, and offers a
 * single, obvious way back to the homepage — see
 * `docs/TEMPLATE_IMPROVEMENT_RECOMMENDATIONS.md` §6.
 */
const NotFound: React.FC = () => {
    return (
        <>
            <Seo title="Page Not Found" path="/404" noindex />
            <section className="not-found">
                <Container className="not-found-content">
                    <p className="not-found-code">404</p>
                    <h1 className="not-found-title">Page not found</h1>
                    <p className="not-found-description">
                        The page you're looking for doesn't exist or may have been moved.
                    </p>
                    <Button as="a" href="/" variant="primary">
                        Back to home
                    </Button>
                </Container>
            </section>
        </>
    );
};

export default NotFound;
